import certificates from '../../Actions/certificates';
const { types } = certificates;

const initialState = {
    certificatesPagination:{
        page: 1,
        pageCount: 1,
        perPage: 10,
        totalCount:10
    },
    certifieds:{
        fileList:[],
        password:''
    }
};

const certificatesReducer = (state = initialState, action) => {

    switch (action.type) {
        
        case types.SET_CERTIFICATES_DATA:            
            return {
                ...state,
                certifieds: {
                    fileList: action.data.fileList,
                    password: action.data.password
                }
            }        
        case types.UPDATE_CERTIFICATES_PAGINATION:            
        return {
            ...state,
            certificatesPagination: action.data
        }       
        default:
            return state;
    }
}

export default certificatesReducer;